<template>
   <div class="flightcard-debugger-container">
      <div class="flightcard-debugger-inner-container">
         <span>{{ infos.channel }}</span>
         <span>{{ infos.identifier }}</span>
         <span>{{ infos.debugger }}</span>
      </div>
   </div>
</template>

<script>
export default {
   name: "FlightCardDebugger",
   props: {
      infos: {
         type: Object,
         required: true,
      },
   },
};
</script>

<style lang="scss" scoped>
.flightcard-debugger-container {
   background-color: #30353c;
   color: #32cd32;
   font-family: monospace;
   font-weight: 500;
   font-size: 1rem;
   padding: 0.5rem;
   margin: 0.5rem;
   border-radius: 0.5rem;

   .flightcard-debugger-inner-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      overflow: auto;
   }
}
</style>
